const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVillasflamingosLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 45,
    viewBox: "0 0 260.04 226.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_villas") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.83,191.85H7.27L0,143H2.5l5.18,39q.18,1.34.32,2.76t.26,2.65q.12,1.45.23,2.85h.12q.06-1.39.23-2.85.11-1.22.26-2.65T9.42,182l5.18-39h2.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.29,144.11a1.39,1.39,0,1,1-.41-1,1.42,1.42,0,0,1,.41,1m-2.56,11.11h2.21v36.63H22.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.62,
    y: 143.01,
    width: 2.21,
    height: 48.85,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.51,
    y: 143.01,
    width: 2.21,
    height: 48.85,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.49,190.69a7.07,7.07,0,0,1-2.06,1.08,8.15,8.15,0,0,1-2.7.44,7.94,7.94,0,0,1-4-.93,6.41,6.41,0,0,1-2.5-2.67,13.2,13.2,0,0,1-1.25-4.25,40.58,40.58,0,0,1-.35-5.58,26.12,26.12,0,0,1,.52-5.23,14.4,14.4,0,0,1,1.8-4.65,12.73,12.73,0,0,1,3.32-3.61,12.27,12.27,0,0,1,5.12-2.09v-1.57a5.92,5.92,0,0,0-.93-3.81,4,4,0,0,0-3.14-1.08,8.37,8.37,0,0,0-2.65.38,15.84,15.84,0,0,0-2.06.84l-.82-1.57a10.32,10.32,0,0,1,2.65-1.08,12,12,0,0,1,3.17-.44q3.31,0,4.62,1.66t1.31,5.2Zm-2.15-26a9.58,9.58,0,0,0-4.19,2A10.63,10.63,0,0,0,55.56,170a14.26,14.26,0,0,0-1.34,4.16,27.8,27.8,0,0,0-.38,4.59,44.82,44.82,0,0,0,.23,4.77,12.66,12.66,0,0,0,.9,3.69,6,6,0,0,0,1.8,2.41,4.69,4.69,0,0,0,2.94.87,4.75,4.75,0,0,0,2.62-.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.11,183.14a14.47,14.47,0,0,1-.41,3.46,9.07,9.07,0,0,1-1.25,2.9,6.26,6.26,0,0,1-2.12,2,6,6,0,0,1-3,.73,7.16,7.16,0,0,1-2.41-.42,6.42,6.42,0,0,1-1.95-1l1-1.5a4.8,4.8,0,0,0,1.28.78,4.46,4.46,0,0,0,1.92.44,3.78,3.78,0,0,0,3.61-2.07,11,11,0,0,0,1.1-5.21,12.08,12.08,0,0,0-.64-4.11,17.71,17.71,0,0,0-1.57-3.29,25.17,25.17,0,0,0-2.06-2.88A22.81,22.81,0,0,1,73.5,170a18.86,18.86,0,0,1-1.57-3.41,13,13,0,0,1-.64-4.28,7.71,7.71,0,0,1,1.83-5.36,6.07,6.07,0,0,1,4.74-2,5.73,5.73,0,0,1,2.35.45,6,6,0,0,1,1.72,1.11l-.81,1.4a10.6,10.6,0,0,0-1.28-.79,4.13,4.13,0,0,0-2-.44,3.77,3.77,0,0,0-3.23,1.54,6.85,6.85,0,0,0-1.13,4.15,10.89,10.89,0,0,0,.64,3.89,15.87,15.87,0,0,0,1.6,3.14q1,1.45,2.06,2.84a28.44,28.44,0,0,1,2.07,3,17.78,17.78,0,0,1,1.6,3.51,14.17,14.17,0,0,1,.64,4.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.72 144.75 104.72 155.22 111.41 155.22 111.41 156.96 104.72 156.96 104.72 191.85 102.4 191.85 102.4 143.01 112.11 143.01 112.11 144.75 104.72 144.75",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.51,
    y: 143.01,
    width: 2.21,
    height: 48.85,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.49,190.69a7.12,7.12,0,0,1-2.06,1.08,8.16,8.16,0,0,1-2.71.44,7.94,7.94,0,0,1-4-.93,6.4,6.4,0,0,1-2.5-2.67,13.14,13.14,0,0,1-1.25-4.25,40.57,40.57,0,0,1-.35-5.58,26,26,0,0,1,.52-5.23,14.34,14.34,0,0,1,1.8-4.65,12.69,12.69,0,0,1,3.32-3.61,12.25,12.25,0,0,1,5.12-2.09v-1.57a5.92,5.92,0,0,0-.93-3.81,4,4,0,0,0-3.14-1.08,8.37,8.37,0,0,0-2.65.38,15.84,15.84,0,0,0-2.06.84l-.81-1.57a10.3,10.3,0,0,1,2.64-1.08,12,12,0,0,1,3.17-.44q3.32,0,4.62,1.66t1.31,5.2Zm-2.15-26a9.57,9.57,0,0,0-4.19,2,10.64,10.64,0,0,0-2.59,3.29,14.38,14.38,0,0,0-1.34,4.16,27.76,27.76,0,0,0-.38,4.59,44.81,44.81,0,0,0,.23,4.77,12.67,12.67,0,0,0,.9,3.69,5.93,5.93,0,0,0,1.8,2.41,4.68,4.68,0,0,0,2.94.87,4.74,4.74,0,0,0,2.62-.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.39,191.85V161.62a5.19,5.19,0,0,0-1.19-3.87,5,5,0,0,0-3.58-1.13,4.47,4.47,0,0,0-2.18.52,6.49,6.49,0,0,0-1.48,1v33.67H158.8V161.56a5.9,5.9,0,0,0-1-3.66q-1-1.28-3.9-1.28a9.63,9.63,0,0,0-2.15.2,8.07,8.07,0,0,0-1.4.44v34.6h-2.21V156.38a11.43,11.43,0,0,1,2.79-1.1,13,13,0,0,1,3.26-.41,7.38,7.38,0,0,1,3.31.67,6.28,6.28,0,0,1,2.09,1.6,6.66,6.66,0,0,1,2.24-1.57,6.85,6.85,0,0,1,2.94-.7,7.18,7.18,0,0,1,5,1.63q1.77,1.63,1.77,5.29v30.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.83,144.11a1.4,1.4,0,1,1-.41-1,1.42,1.42,0,0,1,.41,1m-2.56,11.11h2.21v36.63h-2.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.74,191.85V161.62a9.08,9.08,0,0,0-.17-1.71,4.09,4.09,0,0,0-.7-1.63,3.88,3.88,0,0,0-1.48-1.19,5.83,5.83,0,0,0-2.53-.47,9.22,9.22,0,0,0-2.12.2,8.23,8.23,0,0,0-1.37.44v34.6h-2.21V156.38a11.49,11.49,0,0,1,2.76-1.1,12.62,12.62,0,0,1,3.23-.41,7.75,7.75,0,0,1,3.64.73,5.4,5.4,0,0,1,2.06,1.8,6,6,0,0,1,.9,2.27,12.81,12.81,0,0,1,.2,2.12v30.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.3,192.38a12.83,12.83,0,0,1-1.48,6.75q-1.48,2.38-5.67,2.38a10.32,10.32,0,0,1-2.79-.41,6.5,6.5,0,0,1-2.27-1l.81-1.63a6.91,6.91,0,0,0,1.72.78,7.29,7.29,0,0,0,2.41.44,4.37,4.37,0,0,0,3.9-1.71,9.43,9.43,0,0,0,1.16-5.24V191a6.06,6.06,0,0,1-1.34.67,6.19,6.19,0,0,1-2.21.34,5.23,5.23,0,0,1-3.64-1.34,9.34,9.34,0,0,1-2.38-3.75,24.51,24.51,0,0,1-1.28-5.84,69.88,69.88,0,0,1-.38-7.62,72.29,72.29,0,0,1,.35-7.38,24,24,0,0,1,1.28-5.87,9,9,0,0,1,2.62-3.9,6.72,6.72,0,0,1,4.42-1.4,8.81,8.81,0,0,1,2.85.44,5,5,0,0,1,1.92,1.08Zm-2.21-35.18a4.57,4.57,0,0,0-1-.41,5.81,5.81,0,0,0-1.51-.17,4.4,4.4,0,0,0-3.37,1.37,8.9,8.9,0,0,0-1.95,3.69,25.54,25.54,0,0,0-.87,5.35q-.21,3-.2,6.4t.23,6.54a29.72,29.72,0,0,0,.84,5.35,9.21,9.21,0,0,0,1.71,3.61,3.62,3.62,0,0,0,2.91,1.31,5.57,5.57,0,0,0,2-.29,10,10,0,0,0,1.28-.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.18,173.54q0,4-.26,7.44a27.59,27.59,0,0,1-1,5.9,9.61,9.61,0,0,1-2.12,3.9,5.2,5.2,0,0,1-7.15,0,9.53,9.53,0,0,1-2.12-3.9,27.46,27.46,0,0,1-1-5.9q-.26-3.43-.26-7.44t.26-7.44a27.49,27.49,0,0,1,1-5.9,9.54,9.54,0,0,1,2.12-3.89,5.2,5.2,0,0,1,7.15,0,9.63,9.63,0,0,1,2.12,3.89,27.63,27.63,0,0,1,1,5.9q.26,3.43.26,7.44m-2.27,0q0-3.31-.14-6.37a37.46,37.46,0,0,0-.61-5.41,10.4,10.4,0,0,0-1.39-3.75,3,3,0,0,0-5.12,0,10.68,10.68,0,0,0-1.42,3.75,32.67,32.67,0,0,0-.61,5.41q-.12,3.05-.11,6.37t.11,6.37a32.66,32.66,0,0,0,.61,5.41,10.69,10.69,0,0,0,1.42,3.75,3,3,0,0,0,5.12,0,10.42,10.42,0,0,0,1.39-3.75,37.44,37.44,0,0,0,.61-5.41q.14-3.05.14-6.37",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,183.14a14.47,14.47,0,0,1-.41,3.46,9,9,0,0,1-1.25,2.9,6.27,6.27,0,0,1-2.12,2,6,6,0,0,1-3,.73,7.16,7.16,0,0,1-2.41-.42,6.45,6.45,0,0,1-1.95-1l1-1.5a4.77,4.77,0,0,0,1.28.78,4.44,4.44,0,0,0,1.92.44,3.78,3.78,0,0,0,3.61-2.07,11,11,0,0,0,1.1-5.21,12.1,12.1,0,0,0-.64-4.11,17.72,17.72,0,0,0-1.57-3.29,24.94,24.94,0,0,0-2.06-2.88,22.81,22.81,0,0,1-2.06-2.94,18.87,18.87,0,0,1-1.57-3.41,13,13,0,0,1-.64-4.28,7.71,7.71,0,0,1,1.83-5.36,6.07,6.07,0,0,1,4.74-2,5.73,5.73,0,0,1,2.36.45,6,6,0,0,1,1.72,1.11l-.81,1.4a10.27,10.27,0,0,0-1.28-.79,4.13,4.13,0,0,0-2-.44,3.77,3.77,0,0,0-3.23,1.54,6.85,6.85,0,0,0-1.13,4.15,10.89,10.89,0,0,0,.64,3.89,15.88,15.88,0,0,0,1.6,3.14q1,1.45,2.06,2.84a28.6,28.6,0,0,1,2.07,3,17.67,17.67,0,0,1,1.6,3.51,14.14,14.14,0,0,1,.64,4.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.09 216.14 58.54 216.14 58.54 209.6 56.71 209.6 56.71 224.58 58.54 224.58 58.54 217.86 65.09 217.86 65.09 224.58 66.94 224.58 66.94 209.6 65.09 209.6 65.09 216.14",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.88,209.35a7.75,7.75,0,1,0,7.5,7.74,7.48,7.48,0,0,0-7.5-7.74m0,13.76a6,6,0,0,1,0-12,6,6,0,0,1,0,12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.42 211.33 87.89 211.33 87.89 224.58 89.74 224.58 89.74 211.33 93.24 211.33 93.24 209.61 84.42 209.61 84.42 211.33",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.42 224.58 101.41 224.58 101.41 222.85 96.25 222.85 96.25 217.88 101.37 217.88 101.37 216.16 96.25 216.16 96.25 211.33 101.41 211.33 101.41 209.6 94.42 209.6 94.42 224.58",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.24 209.61 104.39 209.61 104.39 224.58 110.52 224.58 110.52 222.85 106.24 222.85 106.24 209.61",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.88,
    y: 207.39,
    width: 1.47,
    height: 19.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.35 216.14 131.8 216.14 131.8 209.6 129.97 209.6 129.97 224.58 131.8 224.58 131.8 217.86 138.35 217.86 138.35 224.58 140.2 224.58 140.2 209.6 138.35 209.6 138.35 216.14",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.14,209.35a7.75,7.75,0,1,0,7.5,7.74,7.48,7.48,0,0,0-7.5-7.74m0,13.76a6,6,0,0,1,0-12,6,6,0,0,1,0,12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.13 209.61 159.28 209.61 159.28 224.58 165.41 224.58 165.41 222.85 161.13 222.85 161.13 209.61",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.42,216.58a3.39,3.39,0,0,0,1.7-3.09,3.56,3.56,0,0,0-1.58-3.17,4.73,4.73,0,0,0-2.86-.72h-3.85v15h4a5.21,5.21,0,0,0,3.1-.67,4.11,4.11,0,0,0-.52-7.32m-.68,6a4.35,4.35,0,0,1-1.67.27h-2.43v-5.22h2.14a4.17,4.17,0,0,1,1.93.29,2.47,2.47,0,0,1,1.43,2.35,2.36,2.36,0,0,1-1.41,2.32m-.48-6.91a3.68,3.68,0,0,1-1.6.28h-2v-4.63h1.91a3.72,3.72,0,0,1,1.71.32,2.1,2.1,0,0,1,1.07,2,2.13,2.13,0,0,1-1.07,2.06",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,209.35a7.75,7.75,0,1,0,7.5,7.74,7.48,7.48,0,0,0-7.5-7.74m0,13.76a6,6,0,0,1,0-12,6,6,0,0,1,0,12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.99 216.87 203.6 209.6 201.49 209.6 197.91 215.35 194.34 209.6 192.2 209.6 196.84 216.85 191.9 224.57 193.97 224.57 197.86 218.32 201.77 224.51 201.81 224.57 203.95 224.57 198.99 216.87",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.88,47.46s-19.26,30.27-27.2,36.45c-3.73,2.9-7.51,6.18-9.86,6.45A7.15,7.15,0,0,0,97,91.94c3.85,1.09,10.6,1.88,19.17-1.11,3.11-1.08,12.06-31.43,15.18-43.14.07-.27-.2-.74-.52-.23",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6,39.12s21.87,41.5,28.14,49.8a60.28,60.28,0,0,0,14-9.76,251.17,251.17,0,0,1-19.4-17.54C79,52.95,66.25,40.32,65.52,39.31s-1.11-.46-.92-.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.83,47.92s-3.5,25.72-6.68,36.73a75.57,75.57,0,0,1-11.52-7.51s6.91-9.22,9.17-13.14a141.6,141.6,0,0,0,8.39-16.45c.28-.74.78-.42.65.37",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,48.12s18.19,23,27,30.17a48.84,48.84,0,0,0,12.81,7.37,13.37,13.37,0,0,1-5,2.4c-3.84,1.06-12.77.51-15.69-.76-3.37-1.46-15.47-28.11-19.66-39-.1-.25.19-.68.52-.21",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.92,91.57q0-1.09,0-2.19a3.62,3.62,0,0,1,0-.94c.09-.28.52-.54.56-.66.2-.65-.24-.94-.37-1.55a6.25,6.25,0,0,1,.26-2.49c.67-3.47-.25-7.25-.06-10.68a2.1,2.1,0,0,0,.54-.94c.23-.91-.34-1.43-.44-2.4-.13-1.3.36-2.69.3-4-.07-1.78.24-4,.31-5.88,0-1.11.18-1.92.24-3.15.05-1.07.31-1.94.31-3a43.9,43.9,0,0,1,.11-6c.17-1.22,1.25-1.85,1.38-3.06A25.13,25.13,0,0,0,58,42c0-1.1-.08-2.15-.18-3.21a5.29,5.29,0,0,1,0-1.44c.07-.33.37-.49.62-.71s1.19-.68,1.36-1.21c.29-.92-.71-1-1.32-1.24-.8-.33-.9-.91-.9-1.73a4.4,4.4,0,0,1,.64-2,3.45,3.45,0,0,0-.21-2.24c-.2-.86.37-1.42.59-2.19a7.2,7.2,0,0,0-.05-2.79,11.64,11.64,0,0,1,.06-2.62c.14-.95.83-1.68.77-2.7-.08-1.23-1.87-3.12-1-4.55.19-.32.61-.31.77-.63a4,4,0,0,0,0-1.24,27.12,27.12,0,0,1-.21-2.76,2,2,0,0,1,.28-.84c.06-.15.21-.25.28-.41s-.06-.43,0-.63c.45-.87,1.31-.51.58-1.66-.39-.62-.92-1.3-.14-1.87a6.68,6.68,0,0,1,2.07-.69c4.68-1,2.61,5,2.07,7.25A18.81,18.81,0,0,0,64,12.45c-.07.77-.41,1.52-.46,2.34-.1,1.6,0,3.24,0,4.84s0,3.33.07,5,.34,3,.34,4.56a5.19,5.19,0,0,1-.12,2.11c-.36.7-1.44.82-.72,1.51.54.52,1,.63.76,1.59-.32,1.39-1.76,1.22-2.72,1.84-1.31.85,1,1,1.44,1.62,1,1.19.28,4.7-.21,6.06a4.48,4.48,0,0,0-.53,2.33,29.34,29.34,0,0,0,.36,2.95c.33,2.17-.48,3.78-.48,6a22.25,22.25,0,0,1,0,4c-.2,1,.05,3.4-.39,4a3.33,3.33,0,0,0-.37,2c-.13,2.71-.3,3.53-.45,6.19-.14,1.42-.15,3.06-.15,3.72a27.9,27.9,0,0,1-.18,4.69,24.28,24.28,0,0,0-.55,2.39,11.54,11.54,0,0,0,.19,2.09A24.22,24.22,0,0,1,59.88,88c-.51.13-1.07-.3-1.53-.47a5.93,5.93,0,0,0-2.41-.24c-.17.88.92,1.42,1.55,1.55,1,.19,2.59-.81,2.45.23-.06,1.24,1,3.07-.6,3.37a11,11,0,0,0-2.07.26c-.51.19-1.53.83-2,.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.56,94.91c-.34-.36-.4-1.25,0-1.31a12,12,0,0,1,1.29.09c.11-.41.09-1.38.42-1.69s.92-.15,1.25-.12c.23.59,0,1.09.58,1.3s1.61-.36,1.25.78-2.84,2.29-3.82,1.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.29,98.09c-.37-.51-1-1.3-.31-1.66a5,5,0,0,1,2.1.09,1.64,1.64,0,0,0,1.62-.21,3,3,0,0,1,1.9-.56c.14,1.3-.27,1.63-1.29,2.29-.76.49-1.82,1-2.7.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.14,101c-.22-1.19,1,.31,1.52.54,1,.46,1.58.32,1.52-.87,0-.46-.25-.81.2-1a4.56,4.56,0,0,1,1.29,0c.09-.59.5-.72,1.05-.6a13.93,13.93,0,0,1,1.58.35c.45.16.84.61.43,1.08s-1.13.23-1.58.36-1.13.36-1.26.9.3.84,0,1.42c-.71,1.36-2.19.74-3.11.66,0,0-1.25-.55-1.66-2.78",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.77,106.8a.81.81,0,0,1-.17-1.46,2.41,2.41,0,0,1,1.83-.27,1.14,1.14,0,0,1,.83,1.17c-.07.79-.68.49-1.31.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.29,99.89c-.82.07-4.61-.77-4.48-1.79,2.62-.13,5.31.44,7.93.54a25,25,0,0,0,3.54-.41,13.82,13.82,0,0,1,3.23-.34c.13.54-1.13,1.3-1.56,1.61a4,4,0,0,1-2.37.81c-.82,0-1.65.05-2.47.05s-2.45.12-3.06-.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.17,102.79c-1.06,0-5.75.34-5.64-1.44a10,10,0,0,1,2,.27c.71.06,1.47,0,2.18,0a8.52,8.52,0,0,0,2.12-.19c.6-.16,1.25-.16,1.85-.34a11.47,11.47,0,0,1,2-.72c.72-.07,1.49,0,2.21,0a23.91,23.91,0,0,1,4.43.14c.7.14,1.17.62,1.88.76a12.52,12.52,0,0,0,2.49.28c1.61,0,3-.4,4.52-.54a5.4,5.4,0,0,1,2.08.13,8.9,8.9,0,0,0,2.45.54c.24,0,.74-.11,1,0s.31.6.74.75a12.41,12.41,0,0,0,2,.13,11.07,11.07,0,0,0,3.5-.12c.61,1.52-2.34,1.77-3.32,2a18.56,18.56,0,0,1-2,.2,7.58,7.58,0,0,1-1.94.35c-.7-.07-1.16-.59-1.79-.76a9.37,9.37,0,0,0-2-.21,18.24,18.24,0,0,1-2.07-.58c-.44-.07-1.63.13-1,.75a5.53,5.53,0,0,0,2,.73,6,6,0,0,0,2.14.07,1.22,1.22,0,0,1,1.38.41c.28.31-1,.34-1.31.5a3.27,3.27,0,0,1-3.68-.14c-.39-.31-.69-.76-1.09-1.05s-1.22-.39-1-1c.26,0,.62,0,.62-.36s-.57-.3-.77-.35a16,16,0,0,0-1.86-.14c-1.18-.11-2.26-.28-3.47-.28a16.49,16.49,0,0,0-4.13.07,24.9,24.9,0,0,1-3.49.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.76,104c-1.45.83-1.56,1.68-3.35,1.49a6.89,6.89,0,0,1-2.07-.88,5.45,5.45,0,0,0-2.15-.15,5,5,0,0,0-2.35.41c-.4.26-1.54,1.32-.62,1.53.28.06.57-.23.85-.28a6.74,6.74,0,0,1,1.44,0,7.71,7.71,0,0,1,2.67.88,7.45,7.45,0,0,0,3.39.77,5.49,5.49,0,0,0,3.13-1c-.36-.42-1.2-.47-1-1.17a29.69,29.69,0,0,0,3.89-.14,11.75,11.75,0,0,1,3.5-.35c1,.13,1.93.6,2.91.69a20.09,20.09,0,0,0,2.74,0c.28-1.77-3.78-1.32-4.9-1.53a28.73,28.73,0,0,0-3.6-.54c-.79,0-2.32.32-3,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.41,106.59c-.43,0-1.49-.22-1.3.47,1.73-.17,3.81.89,5.31,1.6,1,.46,4.95,1.24,4.7-1-1.38-.06-2.75.2-4.15.2s-2.25-.87-3.52-1.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.42,108.87c1.31,0,2.89-.8,4.19-.47.91.23,1.83.27,2.79.54a7.29,7.29,0,0,1-2.52.95c-.92.09-2.83.26-2.62,1.6a10.5,10.5,0,0,0,3.28-.54,14.7,14.7,0,0,1,3.57-.21,8,8,0,0,1,2.2,0c.63.2,1.23.66,1.9.84a2.7,2.7,0,0,0,3.12-1.08c-.66-.12-1.4.13-2.05,0a12.63,12.63,0,0,1-2.14-1,9.2,9.2,0,0,0-1.83-.84,5.86,5.86,0,0,0-2,0c-1.1-.68-1.9-1.7-3.22-1.83a5.18,5.18,0,0,0-2,.14,11.08,11.08,0,0,0-1.87,1.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.23,107.91c-.36-.13-.89-.77-.56-1.17a3.07,3.07,0,0,1,1.53-.15c.42.14.69.64,1.07.9a2.62,2.62,0,0,0,1.7.49c.62,0,5.41-1.57,4.9.27-1.2.47-2.17,1.61-3.46,1.74a4,4,0,0,1-2.14-.26c-.57-.29-1-.86-1.5-1.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.85,110.74c-.25-.38-1.28-1.09-1.87-.9-.89.3.17,1.34.55,1.73a5,5,0,0,0,3.82,1.24,3.1,3.1,0,0,0,2.08-1c.46-.39,1.58-1.46.8-1.92-1.3-.76-2.53,2.11-3.93,1.41a.12.12,0,0,0-.08-.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.82,114.4a2,2,0,0,0-2.19-.87c-.12.67.55,1.52,1,2.09a2.24,2.24,0,0,0,2.21.79,4.61,4.61,0,0,0,2.4-1.26,8.16,8.16,0,0,0,1-.83c.24-.27.76-.68.7-1.06a2.1,2.1,0,0,0-2,.18c-.57.3-1.3,1-2,.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,118.28c-.74.16-1-.92-1.8-.69-1.2.36.29,1.78.88,2a3.19,3.19,0,0,0,2.47.17,2.24,2.24,0,0,0,1.13-2.33c-.87-.46-1.14,1-2.06.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.61,122.42c-.29-.38-1.71-1.25-1.11-1.72.34-.26.91.1,1.12.23.43.27.34.5.88.6,1.22.22,1.44-.51,2.41-1.07.67-.39,2.1-.53,1.87.69-.69.58-1.42.54-2,1.26-.41.5-1.27,1.52-2,.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.35,98.57c1.65,0,3.5-.53,5.12-.55,1.86,0,3.79.24,5.67.07.71-.06,1.22-.36,1.93-.48.38-.07.66.12,1-.19.52-.52.08-.65-.35-.78-1.29-.37-3.07-.07-4.44-.07-.78,0-1.74.16-2.32-.47.68,0,1.3-.23,2-.22s1.44.1,2.18.14,1.78,0,2.46.07a13.69,13.69,0,0,1,2.05.55,35.11,35.11,0,0,0,3.51.41c1.5.3,2.88.87,4.39,1.18.7.14,1.47,0,2.18.09.25,1.47-3.34,1.48-4.2,1.43-1.49-.08-3-.56-4.42-.76-1.69-.24-3.46.46-5.11.62a23.48,23.48,0,0,1-5.19-.34c-.79-.09-2.24.23-3,.24a6.86,6.86,0,0,1-2.25-.41,9.51,9.51,0,0,1-1.14-.52",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.57,101.27c-.48.48,1.2.11,1.67.25a9.8,9.8,0,0,0,1.65.44,15.32,15.32,0,0,0,3.92.21c2-.27,4.51-.9,6.56-.35,1,0-.67-.68-1.09-.9a5.73,5.73,0,0,0-1.52-.48,10.92,10.92,0,0,0-4.13.28,9.36,9.36,0,0,1-3.61.05c-.79-.2-2.26-1-3-.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.91,102.77a2.81,2.81,0,0,1,.48.19,6.78,6.78,0,0,0,4.24.25c1.73-.33,2.75-.7,4.35.07a2.33,2.33,0,0,1-1.65,1c-.91.2-1.83.56-2.77.78a3.59,3.59,0,0,1-2.54-.36c-.66-.3-1.65-.44-2-1.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.82,103.9a18.39,18.39,0,0,0-2.19.36c-.32,1.12,3.88.75,4.61.89.95.18,1.93-.16,2.83.05.35.08.94.24.68.76-.17.33-1.15.13-1.29.64,1.29.74,3.77,0,5.18-.07a4.78,4.78,0,0,0,2.17-.21c.73-.42,1.23-1,2-1.4,1.1-.53.08-1-.69-1.09a7.32,7.32,0,0,0-2.07.34c-.68.1-1.35.29-2,.35a5.11,5.11,0,0,1-2.38-.55,15.35,15.35,0,0,0-4.95-.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.89,106.94a11.07,11.07,0,0,0-2.13.21,3.21,3.21,0,0,1-2.23-.28c-1.26-.49-3.77-.33-3.79,1.58.45,0,.88-.32,1.33-.39a2.41,2.41,0,0,1,1.7.3,6.44,6.44,0,0,0,3,1.21,5.34,5.34,0,0,0,3.25-.83c1-.64,2-.33,3.15-.4a1,1,0,0,0-.25-.42c-.73-.34-1.89-1.1-2.76-.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.14,105.35c-1.19-.07-4.48.49-4-1.24.14-.69,1.59-.35,1.38-1,.06-.21-.24-.18-.3-.39-2.35.48-1.14-4.76-1.6-6.28-.8-2.62-.55-5.87-.45-8.7.07-1.85.38-2.56.55-4.39a7.71,7.71,0,0,0,0-1.77,14.15,14.15,0,0,0-.38-2.92c-.6-1.43.11-2.92.38-4.3a18.15,18.15,0,0,0-.13-4.32,22.4,22.4,0,0,0-.08-2.79,7.65,7.65,0,0,0,.18-2.95,24.52,24.52,0,0,1,.24-3.14c0-1.05-.21-2.34-.21-3.39,0-1.51-.76-1.6-.28-2.9a8.29,8.29,0,0,0,.55-3.73c0-.41.39-1,.21-1.39a5.16,5.16,0,0,1-.21-2.07c0-.89.72-.85,1.45-.9,1-.06,2.55.36,2.91-.9-.35-1.73-4,.61-4.08-2.21a7,7,0,0,1,0-1.67c.2-.84.88-1.19,1.13-1.94a10.39,10.39,0,0,0,0-3c-.41-.18-.54-.88-.53-1.29,0-.92-.07-.84.82-1.23a9.31,9.31,0,0,1,3.95-.13,2.72,2.72,0,0,1,1.59,2.49,38.2,38.2,0,0,1,0,3.87c0,1.13.23,2.58-.24,3.6-.66,1.44-1.31,1.82-1.42,3.59-.14,2.36-.84,5.88-.32,7.77a24.91,24.91,0,0,1,.46,8.68c-.17,1.34-.5,2.12-.59,3.52a20.11,20.11,0,0,0,.11,4,9.87,9.87,0,0,0,.44,1.8c.21.62.19,1.26.32,1.72a16.61,16.61,0,0,1,.16,3.74c.15,3.06-.44,5.7-.44,8.72a11.22,11.22,0,0,0,.16,2.19c1.08,1.33.75,2.83.8,4.17,0,1,.47,1.65.56,2.65.12,1.3.55,2.63-.26,3.62s-2.8.72-2.35,2.14a1.87,1.87,0,0,0,1.06.14c.55-1.69,1.6-.42,1.68.74.12,1.75-.27,1.72-1.8,1.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.41,32.39a4,4,0,0,1-3.3-1.77c-.39-.82,0-1.18.55-1.61.82-.7.81-.88.81-2,0-1.33.33-2.6.27-3.87,0-.33-.18-.62-.19-.94,0-.66.16-.57.37-.91s1-1.45-.28-1.39a4.77,4.77,0,0,1,.11-3.47,7.28,7.28,0,0,0,0-3.08,50.48,50.48,0,0,1-.46-5.55,17.85,17.85,0,0,1,.16-3.48c.13-.9,0-1.86.12-2.76S136.39.15,137.41,0s1.63,0,2.05,1.11c.55,1.39.25,3.4.25,5a11.28,11.28,0,0,0,.37,2.77,19.73,19.73,0,0,1,.18,2.75,39.1,39.1,0,0,1,.19,5.63c-.09,1.82-.37,3.51-.37,5.44,0,1.74.54,3.21.35,5-.15,1.48.68,4.3-1.64,4.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.31,74.81a19.4,19.4,0,0,0-.18-3.06c-.12-.74-.06-1.56-.18-2.32-.22-1.4,0-3.21-.27-4.7a4.16,4.16,0,0,1-.2-2.1,10.78,10.78,0,0,0,0-2.4,2.91,2.91,0,0,0,0-.86c-.11-.25-.49-.32-.6-.57s.23-.74.23-1.22q0-1.58,0-3.15c0-2.16-.39-4.13-.18-6.27.06-.67.23-1.75-.37-2.3a1.7,1.7,0,0,0-1.75-.3c-.33.07-.76.41-1.09,0s.29-.67.58-.86c.73-.47,1.61.53,2-.6a15.45,15.45,0,0,0-.14-3,14.15,14.15,0,0,0-.35-2.4c-.3-1.91-1.17-1.18-4.31-.95-1.11.08-1.73-.14-1.62,1a14.27,14.27,0,0,1-.09,2.76,4.78,4.78,0,0,0,.26,2.71c.49.73,1.33.54,2,.91.11.91-.58.56-.86,1.09a4.29,4.29,0,0,0-.14,1.52,18.91,18.91,0,0,1,.09,3.18l0,1.57a18.78,18.78,0,0,0,.23,4.93,7.45,7.45,0,0,1-.09,2.9,3.48,3.48,0,0,0,.36,2.7c.35.47.49.23.56.92,0,.46-.52.58-.6,1-.22,1.22.14,3.09,0,4.31-.19,2.11,0,4.32,0,6.43,0,1.81-.09,3.65,0,5.44a9.41,9.41,0,0,1-.39,2.87c-.2.8-.81,1.78-.34,2.55a4.08,4.08,0,0,0,1.17.46c-.24.75-1.19.32-1.58.9s.37,1.18.85,1.41a3.27,3.27,0,0,0,1.64.45c.8-.13.69-.53.77-1.28a1.66,1.66,0,0,1,1.17.18c0,.19,0,.37,0,.56,0,1.09-1.17.76-1.38,1.66-.28,1.16.78,1.29,1.49.84s1-1.5,1.52-2.17c.32-.41,1.72-1.61.21-1.89-.4-.08-.71.51-1.29.35-.29-.08-.92-.61-.93-.92,0-1.05,2.59.62,3.05-.28s.46-3.78.54-6.65c.09-1.79,0-3.61,0-5.4m-3.64,10.58s-2.92,0-2.13-.73c.31-.29,1.55,0,2.19.07s1.55-.61,1.83-.17c.47.74-1.21.83-1.89.83",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,94.33c-.29-.1-.6-.32-.55-.69s1.7-.16,2.74-.12c1.19,0,1.13-.83,1.16-.91s-.11-.32-.39-.36-.79.06-1.15,0c-.6-.14-1.61-.86-.69-1.36.43-.24,1.73-.45,2.16,0,.23.22.31.71.42,1s.26.35.25.69c0,.12.4.33.64.41s.24.16.46.32a1.73,1.73,0,0,0,1.16.19c.77,0,1.86-.34,2.16.56.39,1.17-1.31.88-1.93.61a2.56,2.56,0,0,0-1.34-.34,3.73,3.73,0,0,0-1.29.37,4.25,4.25,0,0,1-1.53.23,4,4,0,0,1-.78,0c-.29-.06-.49-.3-.77-.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.72,97.1c-.29-.16-.82-.7-.78-1.06s.71-.54,1.11-.46.66.53,1.1.72a1,1,0,0,0,1.25-.27c.68-.56,2-.93,2.56,0,.9,1.37-1.2.91-1.81,1.22s-.69.59-1.26.63a2.34,2.34,0,0,1-1.34-.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,99.54c-.45-.1-1.27-.34-1.29-.83s.71-.87,1.2-.83.86.57,1.24.92a2,2,0,0,0,1.11.46c.7.11,1-.39,1.36-.87a1.27,1.27,0,0,1,1.13-.51c.54,0,2.29.86,1.89,1.66-.16.33-.94.34-1.28.37s-.59-.12-.89-.09-.4.25-.67.42c-.94.59-1.94.2-2.88-.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.27,101.57c-.66-.24-1.19-.86-2-.64s.72,1.13,1.1,1.61a6.71,6.71,0,0,0,1.44,1.43,1.56,1.56,0,0,0,1.14.28,2,2,0,0,0,.84-.51c.76-.55,2-1.38,1.74-1.66a1.91,1.91,0,0,0-1.24-.51,1,1,0,0,0-.8.27,1.17,1.17,0,0,1-1.51.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.84,105.67a6.26,6.26,0,0,0-2.45-1c-.43,0-1.11-.24-1.1.33s.76.73,1.07,1.09.68.6,1,1,.46.9,1,1.1a1.2,1.2,0,0,0,1.31-.2c.24-.2.63-.36.81-.62a5.87,5.87,0,0,0,.28-.76,4.49,4.49,0,0,1,1-1.24c.4-.36,1.31-1.12.83-1.13a3.32,3.32,0,0,0-1.56.56,7.57,7.57,0,0,0-1.22.7s-.53.48-.94.16",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.29,36a3.63,3.63,0,0,1-1.92-.37c-.22-.15-.3-.46-.49-.6s-.46,0-.63-.17c-.37-.3-.13-.23-.27-.64-.47-1.4-.06-3,.08-4.4a9.6,9.6,0,0,0,0-2,5.15,5.15,0,0,0-.16-1c-.13-.34-.58-.62-.7-1-.48-1.48.45-3.37.56-4.78a42.07,42.07,0,0,0-.07-5,18.47,18.47,0,0,0-.34-2.13,17.28,17.28,0,0,1-.21-2.78A6.76,6.76,0,0,1,186.21,9c.15-.35.6-.64.84-.95s.5-.78.77-1.12.46-.78.73-1.15.65-.54.93-.86c.49-.54,1-1.77,1.77-1s.4,3.22.5,4.2c.08.82.24,1.66.35,2.49a8.55,8.55,0,0,1,.07,1.17c0,.66-.16.66-.42,1.17-.7,1.39.42,2.67.48,4,0,.75,0,1.52,0,2.27a18.88,18.88,0,0,0,.28,2.07,21.46,21.46,0,0,0,0,2.22,8.48,8.48,0,0,1,.27,1.79c0,1.48,0,3,0,4.5s.73,2.28.83,3.52c.13,1.68-.41,2.62-2.14,2.63Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVillasflamingosLogo);
export default __webpack_public_path__ + "static/media/villasflamingos-logo.d093d529874122fc1063d6916d18b3f3.svg";
export { ForwardRef as ReactComponent };